// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Switch__container___jhK7F {
	margin-top: 10px;
}

/* The switch - the box around the slider */
.Switch__toggle___vQr7A {
	position: relative;
	display: inline-block;
	width: 35px;
	height: 18px;
}

/* Hide default HTML checkbox */
.Switch__toggle___vQr7A input {
	opacity: 0;
	width: 0;
	height: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Switch__container___jhK7F`,
	"toggle": `Switch__toggle___vQr7A`
};
module.exports = ___CSS_LOADER_EXPORT___;
